<template>
  <div class="mdtMobileModal">
    <!-- Modal Overlay -->
    <div class="modal-overlay" @click="$emit('close')">
      <!-- Modal Content -->
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <span class="title">{{ title }}</span>
          <i
            v-if="!hideClose"
            class="fas fa-times icon-close"
            @click="$emit('close')" />
        </div>
        <div class="modal-body">
          <slot name="body-header" />
          <div
            class="body-content">
            <div class="body-content-wrapper">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdtMobileModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color-text-primary-rgb, 0.4);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 16px 16px 26px 15px;
  border-radius: 8px 8px 0 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  color: $color-text-secondary;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 10px;
    border-bottom: 1px solid $color-back-basic;

    .title {
      font-size: 14px;
    }
  }
}
</style>
